module.exports = __webpack_public_path__ + "img/ewm.78b2039e.png";